import { Form, Formik } from "formik";
import Button from "../../../shared/ui/Button";
import { FormRadioGroup } from "../../../shared/ui/Form/FormRadioGroup";
import FormikLabeledInput from "../../../shared/ui/Form/FormikLabeledInput";
import { finalClosureSchema } from "../../../shared/ui/Form/schema";
const panelOptions = [
    { value: "dcr", label: "DCR Panels", subLabel: "with govt. subsidy" },
    {
        value: "non-dcr",
        label: "Non DCR Panels",
        subLabel: "without govt. subsidy",
    },
];

const FinalClosureForm = ({ onSuccess = (values) => {} }) => {
    return (
        <div className="p-4">
            <Formik
                enableReinitialize
                initialValues={{
                    panelType: "dcr",
                    finalPrice: "",
                }}
                validationSchema={finalClosureSchema}
                onSubmit={(values) => {
                    onSuccess(values);
                }}
            >
                {() => (
                    <Form className="space-y-3">
                        <FormRadioGroup
                            name="panelType"
                            label="Panel Type"
                            wrapperClass="flex-col"
                            labelClass="text-xs !text-gray-330"
                            optionContainerClass="gap-3 xsm:ap-5"
                            options={panelOptions}
                        />

                        <FormikLabeledInput
                            label="Final Price"
                            name="finalPrice"
                            required
                            placeholder="XXXXXXX"
                        />

                        <Button
                            type="submit"
                            className="bg-blue-700 text-white w-full"
                        >
                            Submit
                        </Button>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default FinalClosureForm;
